import api from './api';

const BASE = '/api/v1/rooms';

const roomBookingAPI = {
  // Rooms (admin)
  listRooms: (includeInactive = false) =>
    api.get(BASE + '/', { params: { include_inactive: includeInactive } }),

  createRoom: (data) => api.post(BASE + '/', data),

  updateRoom: (id, data) => api.put(`${BASE}/${id}`, data),

  deleteRoom: (id) => api.delete(`${BASE}/${id}`),

  // Bookings (admin)
  listBookings: (params = {}) => api.get(`${BASE}/bookings`, { params }),

  createBooking: (data) => api.post(`${BASE}/bookings`, data),

  updateBooking: (id, data) => api.put(`${BASE}/bookings/${id}`, data),

  deleteBooking: (id) => api.delete(`${BASE}/bookings/${id}`),

  // Public (no auth required)
  publicListRooms: () =>
    api.get(`${BASE}/public/rooms`),

  publicCreateBooking: (data) =>
    api.post(`${BASE}/public/bookings`, data),

  publicCheckAvailability: (roomId, dateFrom, dateTo) =>
    api.get(`${BASE}/public/bookings/availability`, {
      params: { room_id: roomId, date_from: dateFrom, date_to: dateTo },
    }),
};

export default roomBookingAPI;
